// preloadUtils.ts - Preload critical components for better performance
import { ComponentType } from 'react';

// Preload function for components
export const preloadComponent = <T extends ComponentType<any>>(
  importFn: () => Promise<{ default: T }>
) => {
  const componentImport = importFn();
  return componentImport;
};

// Preload critical components when user is authenticated
export const preloadCriticalComponents = () => {
  // Preload the main interface components
  preloadComponent(() => import('../components/AdminInterface'));
  preloadComponent(() => import('../components/DispatcherInterface'));
  preloadComponent(() => import('../components/UnitInterface'));
  
  // Preload radio components in the background
  setTimeout(() => {
    preloadComponent(() => import('../components/radio/RadioPage'));
    preloadComponent(() => import('../components/radio/RadioInterface'));
  }, 2000); // Delay radio preload to prioritize main interfaces
};

// Preload components based on user role
export const preloadRoleComponents = (role: string) => {
  switch (role) {
    case 'admin':
      preloadComponent(() => import('../components/AdminInterface'));
      break;
    case 'dispatcher':
      preloadComponent(() => import('../components/DispatcherInterface'));
      break;
    case 'unit':
      preloadComponent(() => import('../components/UnitInterface'));
      break;
  }
};
